import { Tabs } from 'antd';
import LoaderComponent from '../../Loader';
import { PersistedTabs } from '../../PersistedSections';
import StripeCards from './StripeCards';
import SubscriptionSummary from './SubscriptionSummary';

const { TabPane } = Tabs;

export default function SubscriptionDetails({
  loading,
  summaryData,
  getData,
  userId,
  invoices,
  customer,
  charges,
  disputes
}) {
  return <>
  {
    loading ? <LoaderComponent /> : 
      (
       <>
          <PersistedTabs name="subscription-details-tab" defaultActiveKey="1" centered>
            <TabPane tab="Subscription Summary" key="1">
              <SubscriptionSummary
                subscriptions={summaryData.subscriptions}
                loading={loading}
                refreshList={getData}
                invoices={invoices}
                customer={customer}
                charges={charges}
                disputes={disputes}
              />
            </TabPane>
            <TabPane tab="Stripe Cards" key="2">
              <StripeCards
                userId={userId} 
                refreshData={getData}
                stripeCards={summaryData?.stripeCards}
                loading={loading} />
            </TabPane>
          </PersistedTabs>
       
       </>
      )
  }
</>
}